import { useState } from 'react';
import { useAppSelector } from '@/store/hooks';
import { subscripePlan } from '../../../apiServices/groupApi';
import PackageCard from './packageCard';
import { Spinner } from '@/components/ui/Spinner';

interface Package {
  name: string;
  price: number;
  storage: number;
  admins: number;
  data_transfer: number;
}

export function PackagesView() {
  const { createdGroup, packages } = useAppSelector((state) => state.workspace);
  const [loading, setLoading] = useState(false);

  const onCardButtonClick = (plan: string) => {
    if (loading || !createdGroup) return;
    setLoading(true);
    subscripePlan(createdGroup.id, plan)
      .then((res: { response?: string }) => {
        if (res.response) {
          window.location.href = res.response;
        }
      })
      .catch((err: unknown) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <div className="mx-auto max-w-4xl px-6 py-12">
      <h1 className="text-2xl font-bold text-foreground">You&apos;re almost there</h1>
      <div className="mt-4 space-y-3 text-sm text-muted-foreground">
        <p>
          Choose the most suitable plan for your business and fill out your payment card information
          on Stripe, our partner service.
        </p>
        <p>
          Yemma is free for the first 14 days and your payment card will only be charged after the
          free period. During the free period, you can easily stop using the service and deactivate
          your account.
        </p>
      </div>
      <h2 className="mt-8 text-lg font-semibold text-foreground">Select a plan</h2>
      <div className="mt-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {(packages as Package[] | null)?.map((i) => {
          const storage = i.storage < 1000 ? `${i.storage} GB` : `${i.storage / 1000} TB`;
          return (
            <PackageCard
              key={i.name}
              title={i.name}
              price={i.price}
              onButtonClick={() => onCardButtonClick(i.name)}
              buttonText="Purchase"
              features={[
                'all functionalities',
                `${i.admins} admin users`,
                'unlimited other users',
                `${storage} of storage space`,
                `data transfer ${i.data_transfer} GB per month`,
              ]}
            />
          );
        })}
      </div>
      <p className="mt-6 text-xs text-muted-foreground">
        The cost of additional storage space for the part exceeding the contract is € 0.10 per
        GB/month and the data transfer cost for the part exceeding the contract is € 0.20 per
        GB/month. VAT is not included in the prices.
      </p>
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-overlay">
          <Spinner size="lg" />
        </div>
      )}
    </div>
  );
}

export default PackagesView;
